// extracted by mini-css-extract-plugin
export default {"name_description":"HongKongForm_name_description__REOXF"};